// Page « Équité salariale » (L05, F-600) — PLACEHOLDER trivial.
// Le vrai module d'équité (analyse comparative, écarts, plans de correction) est
// un outil du comité exécutif (L06+). Ici, une route honnête avec EmptyState —
// aucune donnée, aucune PII servie (parite ComingSoonPage : mieux qu'un item de
// nav qui redirigerait silencieusement). Cote PoC : `requireAdmin` (CE). Aucun
// item de nav ne pointe cette route (comme /mon-equipe) ; l'entree se fait par
// URL. Le contenu ne portant aucune donnee, aucune garde de role n'est requise.
import { PageHeader, EmptyState } from '@gs/ui';
import { Scale } from 'lucide-react';
import { useTranslation } from '../../i18n';

export default function EquiteSalarialePage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <PageHeader title={t('gest:planification.equite.title')} />
      <EmptyState
        title={t('gest:accueil.comingSoon.title')}
        description={t('gest:planification.equite.description')}
        icon={<Scale size={40} className="text-slate-300 dark:text-slate-600" aria-hidden />}
      />
    </div>
  );
}
